<template>
  <div>
    <component :is="resolveLayoutVariant" :class="`skin-variant--${appSkinVariant}`">
      <transition :name="appRouteTransition" mode="out-in" appear>
        <router-view :class="{ 'layout-blank': isLayoutBlank }"></router-view>
      </transition>
    </component>
  </div>
</template>

<script>
  // eslint-disable-next-line object-curly-newline
  import useAppConfig from "@core/@app-config/useAppConfig";
  import { useLayout } from "@core/layouts/composable/useLayout";
  import { useRouter } from "@core/utils";

  // Dynamic vh
  import useDynamicVh from "@core/utils/useDynamicVh";
  import { computed } from "@vue/composition-api";
  import LayoutBlank from "../src/layouts/blank/LayoutBlank.vue";
  import LayoutContentHorizontalNav from "../src/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue";

  // Layouts
  import LayoutContentVerticalNav from "../src/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue";

  import setVuetifyColorsCssVariables from "@/@core/utils/colors";
  import themeConfig from "@themeConfig";
  // Utils
  import { loadGrooveChatScript, loadScripts } from "@/utility/3rdPartyScripts";

  export default {
    components: {
      LayoutContentVerticalNav,
      LayoutContentHorizontalNav,
      LayoutBlank,
    },
    setup() {
      const { route, router } = useRouter();
      const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig();

      const { handleBreakpointLayoutSwitch } = useLayout();
      handleBreakpointLayoutSwitch();

      const resolveLayoutVariant = computed(() => {
        if (route.value.meta.layout === "blank") return "layout-blank";

        return `layout-content-${appContentLayoutNav.value}-nav`;
      });

      const isLayoutBlank = computed(() => {
        return route.value.meta.layout === "blank";
      });

      useDynamicVh();

      return {
        resolveLayoutVariant,
        appSkinVariant,
        appRouteTransition,
        route,
        router,
        isLayoutBlank,
      };
    },
    async created() {
      if (!this.$store.state.tinymceCss) {
        const css = await fetch(process.env.VUE_APP_API_URL + "/css/tinymce");
        const cssText = await css.text();
        this.$store.commit("SET_TINYMCE_CSS", cssText);
      }
    },
    async mounted() {
      this.router.afterEach(() => {
        this.router.app.$nextTick(() => {
          if (this.route.meta?.tinymce) {
            return;
          }
          // Load 3rd party scripts
          if (this.$can("view", "cookie bar")) {
            // const parsedBrowserCookie = getCookie("cookie_list");
            loadScripts();
          }
          loadGrooveChatScript();
        });
      });
    },
    watch: {
      route: {
        handler(newRoute) {
          if (newRoute?.meta?.onlyLightTheme) {
            // Don't set localstorage value here so that we can restore user preference once user is not in auth views anymore;
            this.$vuetify.theme.dark = false;
            setVuetifyColorsCssVariables(themeConfig, "light");
          } else {
            const isDark = localStorage.getItem("materio-active-theme") === "dark";
            if (isDark && !this.$vuetify.theme.dark) {
              this.$vuetify.theme.dark = true;
              setVuetifyColorsCssVariables(themeConfig, "dark");
            }
          }
        },
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/functions.scss";

  .layout-blank {
    background: get-color("white") !important;
  }
</style>
